import Vue from 'vue';
import Vuex from 'vuex';

import Card from "../model/card";
import User from "../model/user";

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		card: new Card(),
	},
	actions: {
		initCart({ dispatch }) {
			dispatch('createCard');
		},
		async createCard({ commit}, payload) {
			const card = new Card(new User());
			commit('updateCart', card);
		},

	},
	mutations: {
		updateCard(state, card) {
			state.card = card;
		}
	}
});

export default store;